import axios from 'axios'

export const api = axios.create({
  headers: {
    'X-Strategy': 'token',
    Authorization: `Bearer ${process.env.REACT_APP_CNPJ_TOKEN}`
  }
})

export interface CnpjDataRaw {
  cnpj: string
  razaoSocial: string
  nomeFantasia?: string
  capitalSocial: string
  dataAbertura: string
  situacao: string
  dataSituacao: string
  situacaoEspecial?: string
  dataSituacaoEspecial?: string
  porte: {
    id?: string
    descricao?: string
  }
  natureza: {
    id?: string
    descricao?: string
  }
  simples: {
    optante?: boolean
    dataOpcao?: string
  }
  simei: {
    optante?: boolean
    dataOpcao?: string
  }
  endereco: {
    cep?: string
    logradouro?: string
    numero?: string
    complemento?: string
    bairro?: string
    municipio?: string
    ibgeMunicipio?: string
    uf?: string
    ibgeEstado?: string
  }
  contato: {
    telefones: string[]
    emails: string[]
  }
  cnaePrincipal: {
    id?: string
    descricao?: string
  }
  cnaeSecundarios: Array<{
    id?: string
    descricao?: string
  }>
  inscricoesEstaduais: Array<{
    numero?: string
    uf?: string
    ativo?: boolean
    dataStatus?: string
  }>
  socios: Array<{
    cpfCnpj?: string
    tipo?: string
    nome?: string
    dataEntrada?: string
    cpfRepresentante?: string
    nomeRepresentante?: string
    qualificacao?: {
      id?: string
      descricao?: string
    }
  }>
}

export interface CnpjData extends CnpjDataRaw {
  dataAberturaFormatted: string
}

export async function getCnpjData(cnpj: string): Promise<CnpjData | undefined> {
  const url = `${process.env.REACT_APP_CNPJ_URL}/${cnpj}`
  const response = await api.get<CnpjDataRaw>(url)

  if (response.status !== 200) return

  const cnpjData = response.data

  return {
    ...cnpjData,
    dataAberturaFormatted: cnpjData.dataAbertura?.split('-').reverse().join('/')
  }
}
